(function(){
  if(window.twSewSteadyReady)return;window.twSewSteadyReady=true;
  function validate(form){
    form.querySelectorAll('[data-tw-sew-fields] input[type="text"]').forEach(function(el){el.value=el.value.trim();});
    return form.reportValidity();
  }
  async function add(form){
    if(form.dataset.twSubmitting==='true'||!validate(form))return;
    var box=form.querySelector('[data-tw-sew-fields]'), error=box.querySelector('[role="alert"]');
    var submit=form.querySelector('[type="submit"]');
    error.hidden=true;form.dataset.twSubmitting='true';if(submit)submit.disabled=true;
    try{
      var root=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
      var response=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      var data=await response.json();
      if(!response.ok)throw new Error(data.description||'We could not add this custom order. Please try again.');
      window.location.assign(root+'cart');
    }catch(err){error.textContent=err.message;error.hidden=false;form.dataset.twSubmitting='false';if(submit)submit.disabled=false;}
  }
  document.addEventListener('click',function(e){
    var button=e.target.closest('button[type="submit"],input[type="submit"]');
    var form=button&&button.form;
    if(!form||!form.querySelector('[data-tw-sew-fields]'))return;
    e.preventDefault();e.stopImmediatePropagation();add(form);
  },true);
  document.addEventListener('submit',function(e){
    var form=e.target;if(!form.querySelector('[data-tw-sew-fields]'))return;
    e.preventDefault();e.stopImmediatePropagation();add(form);
  },true);
})();

(function(){
  function organize(){
    document.querySelectorAll('.tw-sew-description').forEach(function(root){
      if(root.querySelector('details'))return;
      var headings=Array.from(root.children).filter(function(el){return el.tagName==='H3';});
      if(!headings.some(function(el){return el.textContent.trim()==='Specifications at a glance';}))return;
      var groups=[
        {title:'Specifications & what’s included',id:'tw-sew-specs',names:['Why choose this style?','Specifications at a glance'],open:true},
        {title:'Machine fit & choosing your setup',id:'tw-sew-fit',names:['Is this the right style for you?','Custom fit: what we need from you']},
        {title:'Ordering, processing & delivery',id:'tw-sew-order',names:['Ordering from ThreadWorks']},
        {title:'Questions & planning tips',id:'tw-sew-faq',names:['Questions before you order?','Plan your sewing station','Plan your ruler-work setup','Measure once more before ordering','Check your existing Versa pieces','Coordinate the table and cutout order']}
      ];
      var boundary=headings[0], marker=document.createTextNode('');root.insertBefore(marker,boundary);
      groups.forEach(function(group){
        var details=document.createElement('details'), summary=document.createElement('summary'), body=document.createElement('div');
        details.className='tw-sew-detail';details.id=group.id;details.open=!!group.open;summary.textContent=group.title;body.className='tw-sew-detail-body';
        group.names.forEach(function(name){
          var heading=headings.find(function(el){return el.textContent.trim()===name;});if(!heading)return;
          var node=heading;
          do{var next=node.nextSibling;body.appendChild(node);node=next;}while(node&&node.nodeName!=='H3');
        });
        details.appendChild(summary);details.appendChild(body);root.insertBefore(details,marker);
      });marker.remove();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',organize);else organize();
  document.addEventListener('shopify:section:load',organize);
  document.addEventListener('click',function(event){
    var link=event.target.closest('.tw-sew-links a[href^="#"]');if(!link)return;
    var target=document.getElementById(link.getAttribute('href').slice(1));if(target&&target.tagName==='DETAILS')target.open=true;
  });
})();

(function(){
  function priceFor(select){
    var article=select.closest('article'), option=select.selectedOptions[0];if(!article||!option)return;
    var price=article.querySelector('[data-tw-sew-price]'),retail=article.querySelector('[data-tw-sew-retail]');
    if(price)price.textContent=option.dataset.price;if(retail)retail.textContent=option.dataset.retail;
  }
  document.addEventListener('change',function(event){if(event.target.matches('[data-tw-sew-variant]'))priceFor(event.target);});
  function init(){document.querySelectorAll('[data-tw-sew-variant]').forEach(priceFor);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
